/**
 * Plugin for the product sorting
 */
export class ProductSort {
    protected element: HTMLSelectElement;
    protected defaultSort: string = 'relevance';
    protected scrollTo: string;
    protected sort: string;

    constructor(element: HTMLSelectElement) {
        this.element = element;
        this.scrollTo = element.dataset.scrollTo;

        if (element.dataset.defaultSort) {
            this.defaultSort = element.dataset.defaultSort;
        }

        this.#init();
    }

    /**
     * Initialize the product sort
     *
     * @private
     */
    #init = () => {
        const url = new URL(window.location.toString());

        this.sort = url.searchParams.get('sort');
        if (!this.sort) {
            this.sort = this.defaultSort;
        }

        this.element.value = this.sort;

        this.element.addEventListener('change', (e) => {
            e.stopPropagation();
            this.sort = this.element.value;

            if (this.scrollTo) {
                url.hash = this.scrollTo;
            }

            url.searchParams.set('sort', this.sort);
            window.location.replace(url);
        }, {passive: false});
    }

    /**
     * Create Product-Sort from a NodeList of HTMLSelectElements
     *
     * @param {NodeListOf<HTMLSelectElement>} elementList
     */
    static createInstances = (elementList:NodeListOf<HTMLSelectElement>) => {
        Array.from(elementList).forEach((el) => {
            const productSort = new ProductSort(el);
        });
    }
}

/**
 * Initialize productSort
 */
export function initProductSort() {
    ProductSort.createInstances(document.querySelectorAll('.sorting-select'));
}
